<mat-list role="list" class="list-plantillas">
  <mat-list-item role="listitem" *ngFor="let item of lstEmpleadosFiltered">
    {{ item.IdLegajo + ' - ' + item.Nombre + ' ' + item.Apellido }}
  </mat-list-item>
</mat-list>